export default __webpack_public_path__ + "static/media/ic_weather_1.fda5f3c9.svg";